import './LeadForm.css';
import React, {Component}   from 'react';
import { Field, reduxForm } from 'redux-form';

const normalizeLength = value => {
    const nValue = ( value.length > 300 ) ? value.substr( 0, 300 ) : value;
    return nValue;
};

let LeadForm = props => {
    const {
        handleSubmit,
        pristine,
        reset,
        submitting
    } = props;
    return (
        <form onSubmit={ handleSubmit } className='lead-form'>
            <div className='input-pair first-name'>
                <div className='ip-label'>
                    <label>First Name</label>
                </div>
                <div className='input-field'>
                    <Field
                        name="firstName"
                        component="input"
                        type="text"
                        placeholder="First Name"
                        normalize={normalizeLength}
                    />
                </div>
            </div>
            <div className='input-pair last-name'>
                <div className='ip-label'>
                    <label>Last Name</label>
                </div>
                <div className='input-field'>
                    <Field
                        name="lastName"
                        component="input"
                        type="text"
                        placeholder="Last Name"
                        normalize={normalizeLength}
                    />
                </div>
            </div>
            <div className='input-pair'>
                <div className='ip-label'>
                    <label>Email</label>
                </div>
                <div className='input-field'>
                    <Field
                        name="eMail"
                        component="input"
                        type="text"
                        placeholder="e-mail"
                        normalize={normalizeLength}
                    />
                </div>
            </div>
            <div className='input-pair'>
                <label>Questions / Comments / Insights</label>
                <div>
                    <Field
                        name="comment"
                        component="textarea"
                        normalize={normalizeLength}
                    />
                </div>
            </div>
            <div className='controls'>
                <button type="submit">Submit</button>
            </div>

        </form>
    );

};

LeadForm = reduxForm({
    form: 'lead-form'
})(LeadForm);

export default LeadForm;




// WEBPACK FOOTER //
// ./src/components/leadForm/LeadForm.js